module.exports = __webpack_public_path__ + "static/21-503ad52a24e1d2aeda60189804e67391.png";